import { scheduleExport } from '../../store/actions/export'
import {
    historyGenerate,
    historyLoadAudit,
    historyLoadExports,
    historyLoadVersionData,
    historyLoadVersions,
} from '../../store/actions/history'
import { referenceLoad } from '../../store/actions/references'
import { exportActions } from '../../store/slices/export'
import { historyActions } from '../../store/slices/history'
import { historyPageActions } from '../../store/slices/historyPage'

export const historyEffectsActions = {
    referenceLoadGroups: () => referenceLoad('groups'),
    historyLoadExports,
    historyLoadAudit,
    historyLoadVersions,
}

export const historyTabsActions = {
    setActiveTab: historyPageActions.setActiveTab,
}

export const historyExportFormActions = {
    setExportGroup: historyPageActions.setExportGroup,
    setSaveOnServer: historyPageActions.setSaveOnServer,
    scheduleExport,
    historyGenerate,
    resetExportNotice: exportActions.resetNotice,
}

export const historyExportsListActions = {
    historyLoadExports,
}

export const historyVersionsTabActions = {
    openVersion: historyPageActions.openVersion,
    closeVersion: historyPageActions.closeVersion,
    setVersionTable: historyPageActions.setVersionTable,
    historyLoadVersionData,
    resetVersionData: historyActions.setVersionData,
    resetVersionDataError: historyActions.setVersionDataError,
}
